import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { api } from "../lib/api";

const HEARTBEAT_MS = 30_000;
const REFETCH_MS = 30_000;

/**
 * usePresence — fires a 30s heartbeat to /v2/docs/:id/presence and polls the
 * presence list every 30s. Returns the current readers (excluding the
 * caller). Disabled when docId is empty.
 */
export function usePresence(docId: string | undefined, sectionId?: string) {
  useEffect(() => {
    if (!docId) return;
    const beat = () => {
      void api.heartbeatPresence(docId, { sectionId }).catch(() => undefined);
    };
    beat();
    const interval = window.setInterval(beat, HEARTBEAT_MS);
    return () => window.clearInterval(interval);
  }, [docId, sectionId]);

  return useQuery({
    queryKey: ["presence", docId],
    queryFn: () => api.listPresence(docId ?? ""),
    enabled: !!docId,
    refetchInterval: REFETCH_MS,
    staleTime: 0,
  });
}
